//For big itins this should be turned off even in dev mode
export const DEVTOOLS_ENABLED = import.meta.env.MODE !== 'production'
